import Mousetrap from 'mousetrap'

;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('CompanyTemplateListController', CompanyTemplateListController)

  /* @ngInject */
  function CompanyTemplateListController ($scope, $translate, $rootScope, $timeout, $stateParams, $state, $location, $q, NewAssetService, ArtsService, CONSTANTS, Utils, ModalService, MessageService, ToastService, AdminService, GroupService, ProductsService, TemplateService, SegmentService, AssetPreviewService, UdsModalService, FormatsService, TagsService, ConfirmationModalService, CampaignService) {
    const getDownloadDialogController = () => $q.when(import('../../dialogs/download/download-dialog.controller'))
    const getShareArtDialogController = () => $q.when(import('../../dialogs/share-art/share-art-dialog.controller'))
    const getUploadTemplateDialogController = () => $q.when(import('../../dialogs/upload-template/upload-template-dialog.controller'))
    const getArchiveTemplateDialogController = () => $q.when(import('../../dialogs/archive-template/archive-template-dialog.controller'))
    const getUnarchiveTemplateDialogController = () => $q.when(import('../../dialogs/unarchive-template/unarchive-template-dialog.controller'))
    const getMoveTemplateCollectionController = () => $q.when(import('../../dialogs/move-template-collection/move-template-collection-dialog.controller'))
    const getImportSvgDialogController = () => $q.when(import('../../dialogs/import/import-dialog.controller'))
    const getArtSizeDialogController = () => $q.when(import('../../dialogs/art-size/art-size-dialog.controller'))
    const getTemplatePropertiesDialogController = () => $q.when(import('../../dialogs/template-properties/template-properties-dialog.controller'))
    const getAttachInsideTheModuleModalController = () => $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))
    const getImportTemplateNoCustomizableController = () => $q.when(import('../../dialogs/import-template-no-customizable/import-template-no-customizable.controller'))

    $scope.top = 10
    $scope.visualization = 'thumb'
    $scope.selectedTemplates = []
    $scope.loading = false
    $scope.location = 'materials'
    $scope.floatingBarLocation = 'materialsManagement'
    $scope.companyFeatures = {
      artsCustomization: {
        access: true
      }
    }

    $scope.listHeader = [
      { label: $translate.instant('title'), value: 'name' },
      { label: $translate.instant('product'), value: 'productTitle' },
      { label: $translate.instant('measures'), value: 'measures' },
      { label: $translate.instant('date'), value: 'updatedAt' }
    ]

    $scope.selectedOrder = {
      name: 'updatedAt',
      order: 'DESC'
    }
    $scope.oFilters = null

    $scope.search = ''

    $scope.skipPagingTo = skipPagingTo
    $scope.tokensCount = 3
    $scope.productsCount = 0

    $scope.templateButtons = {
      download: true,
      share: true,
      archive: true,
      duplicate: true
    }

    let thumbTop

    const api = {
      getDownloadDialogController,
      getShareArtDialogController,
      getUploadTemplateDialogController,
      getArchiveTemplateDialogController,
      getUnarchiveTemplateDialogController,
      getMoveTemplateCollectionController,
      getImportSvgDialogController,
      getArtSizeDialogController,
      getTemplatePropertiesDialogController,
      getAttachInsideTheModuleModalController,
      getImportTemplateNoCustomizableController,
      _handleCompanyFeatures,
      _openTemplatePropertiesDialog,
      _successGetTemplates,
      pixelToCentimeter,
      _calcCardsPerLine,
      _openTemplateDialog,
      _checkIfPageExists,
      _batchArchiveTemplates,
      _batchUnarchiveTemplates,
      _moveToCollection,
      _handleQuickPreview,
      _handleOpenQuickPreview,
      _openImportTemplate,
      _openImportModal,
      _openFormatDialog,
      _changeVisualization,
      _onSearch,
      _setHeader,
      _openBulkTemplateDialog,
      _archiveTemplates,
      _onFilter,
      _unselectAllAssets,
      _archiveArt
    }
    this.getApi = () => api

    activate()

    function activate () {
      $scope.$emit('arts.change-selectedMenuId', 3)
      SegmentService.track('arts-brandtemplate-pageview')
      api._handleCompanyFeatures()
        .then(() => {
          api._setHeader('thumb')
        })

      if ($stateParams.previewId) {
        TemplateService.getTemplateById($stateParams.previewId).then((template) => {
          AssetPreviewService.openAssetPreview({
            asset: template,
            getPreviewAssets: $scope.getPreviewAssets
          })
        })
      }
      api._handleQuickPreview()

      if (!$rootScope.isDesktop) {
        $scope.visualization = 'list'
      } else {
        api._calcCardsPerLine()
      }

      if ($stateParams.search) {
        $scope.search = $stateParams.search
      }

      if ($stateParams.template) {
        $scope.openAssetPreview($stateParams.template, $scope.location)
      }
    }

    const deregisterReloadArtsPage = $scope.$on('reload-arts-page', (ev, args) => {
      if (args.emitter === 'unarchiveTemplate') {
        $scope.oFilters.isArchived = false
      }
      if ($stateParams.page && $scope.templates.length > 1) {
        skipPagingTo($stateParams.page, true)
      } else {
        skipPagingTo(0)
      }
      $timeout(() => {
        $scope.selectedTemplates = []
        api._setHeader($scope.visualization)
      }, 100)
    })

    $scope.$on('$destroy', () => {
      deregisterReloadArtsPage()
      Mousetrap.unbind('space')
      AssetPreviewService.closePreview()
    })

    function _onSearch (term) {
      $scope.search = term
      skipPagingTo(0)
    }

    $scope.setFilters = function (filters) {
      $scope.oFilters = filters
      skipPagingTo(0)
    }

    function _changeVisualization (visualization) {
      api._unselectAllAssets()
      if ($rootScope.isDesktop) {
        if (visualization === 'list') {
          $scope.top = 10
        } else {
          $scope.top = thumbTop
        }
      }
      $scope.visualization = visualization
      api._setHeader(visualization)
      skipPagingTo(0, null, visualization)
    }

    $scope.getThumbUrl = function (template) {
      if (template.isCustomizable || template.thumbnailContentType || template.hasCover) {
        const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_THUMBNAIL, [template.id])
        const cached = Utils.fnAddQueryToUrl(url, { cache: template.updatedAt })
        return cached
      } else {
        return TemplateService.getDefaultThumbnail(template.extension)
      }
    }

    $scope.sortListClick = function (field) {
      if (!$rootScope.isDesktop) {
        $scope.selectedOrder.name = field
        $scope.selectedOrder.order = 'DESC'
      } else {
        if ($scope.selectedOrder.name === field) {
          if ($scope.selectedOrder.order === 'ASC') {
            $scope.selectedOrder.order = 'DESC'
          } else if ($scope.selectedOrder.order === 'DESC') {
            $scope.selectedOrder.order = ''
            $scope.selectedOrder.name = ''
          }
        } else {
          $scope.selectedOrder.name = field
          $scope.selectedOrder.order = 'ASC'
        }
      }
      skipPagingTo(0, null, 'list')
    }

    $scope.openImportModal = function () {
      api.getImportSvgDialogController().then(({ ImportSvg }) => {
        const addCompanyDialog = UdsModalService.createModal({
          controller: ImportSvg,
          modalName: 'importDialog'
        })

        addCompanyDialog.open()
      })
    }

    $scope.openImportTemplate = () => {
      getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
        const attachInsideTheModuleModal = UdsModalService.createModal({
          controller: AttachInsideTheModuleModalController,
          modalName: 'attachInsideTheModuleModal',
          data: {
            selectedTab: 'recents',
            location: 'materials',
            avoidSuccessOnConfirm: true
          },
          onClose: async (assetsToAttach) => {
            if (!assetsToAttach?.length) {
              return
            }

            api._openTemplatePropertiesDialog(assetsToAttach)
          }
        })

        attachInsideTheModuleModal.open()
      })
    }

    function _openBulkTemplateDialog (assets) {
      Mousetrap.unbind('space')

      const bulkTemplates = assets.length > 1
      const allCustomizable = assets.every(asset => asset?.isCustomizable)

      api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
        const templatePropertiesDialog = UdsModalService.createModal({
          controller: TemplatePropertiesDialogController,
          modalName: 'templatePropertiesDialog',
          data: {
            bulkTemplates,
            shouldConvertToTemplate: false,
            isEditing: true,
            isCustomizable: allCustomizable,
            assets,
            location: 'materialsManagement'
          },
          onClose: (info) => {
            Mousetrap.bind('space', api._handleOpenQuickPreview)

            if (info && info.wasUpdated) {
              $rootScope.$broadcast('reload-arts-page')
            }
          }
        })

        templatePropertiesDialog.open()
      })
    }

    $scope.changeTemplateSelected = function (template) {
      if (template.selected) {
        $scope.selectedTemplates.push(template)
      } else {
        const index = $scope.selectedTemplates.findIndex(item => item.id === template.id)

        if (index >= 0) {
          $scope.selectedTemplates.splice(index, 1)
        }
      }

      api._setHeader($scope.visualization)
    }

    function _openTemplatePropertiesDialog (assetsToAttach) {
      const assetsDetailsPromises = assetsToAttach.map((asset) => NewAssetService.getAssetDetails(asset.id, { formatData: 'raw' }))

      Promise.all(assetsDetailsPromises).then((assetsDetails) => {
        const bulkTemplates = assetsToAttach.length > 1
        api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
          const templatePropertiesDialog = UdsModalService.createModal({
            controller: TemplatePropertiesDialogController,
            modalName: 'templatePropertiesDialog',
            data: {
              bulkTemplates,
              assets: assetsDetails,
              isCustomizable: false
            }
          })

          templatePropertiesDialog.open()
        })
      })
    }

    function _handleQuickPreview () {
      if (!AssetPreviewService.isPreviewEnabled()) {
        return
      }

      Mousetrap.bind('space', api._handleOpenQuickPreview)
    }

    function _handleOpenQuickPreview (ev) {
      const isSpaceBar = ev.code !== 'Space' && ev.keyCode !== 32
      if (isSpaceBar || ev.repeat || !$scope.selectedTemplates.length) {
        return
      }

      if (!AssetPreviewService.assetPreviewIsOpen() && AssetPreviewService.assetQuickPreviewIsOpen()) {
        ev.preventDefault()
        AssetPreviewService.closePreview()
        return
      }

      if (!AssetPreviewService.assetPreviewIsOpen() && !AssetPreviewService.assetQuickPreviewIsOpen()) {
        ev.preventDefault()
        AssetPreviewService.openAssetQuickPreview({
          currentAsset: $scope.selectedTemplates[$scope.selectedTemplates.length - 1],
          assets: $scope.templates
        })
      }
    }

    $scope.handleOpenQuickPreview = (event) => api._handleOpenQuickPreview(event)

    $scope.openShareDialog = function (template) {
      api.getShareArtDialogController().then(({ ShareArtDialogController }) => {
        const shareArtDialog = UdsModalService.createModal({
          controller: ShareArtDialogController,
          modalName: 'shareArtDialog',
          data: {
            art: template
          }
        })

        shareArtDialog.open()
      })
    }

    $scope.archiveTemplateClick = function (template) {
      if (template?.isTemplate) {
        const message = template.isCustomizable ? $translate.instant('archiveTemplateDialogText') : $translate.instant('areYouSureArchiveTemplate')

        const modalConfig = {
          title: $translate.instant('archive'),
          buttonCancelText: $translate.instant('cancel'),
          buttonConfirmText: $translate.instant('campaignEdit.archiveConfirm.confirm'),
          onConfirm: () => {
            api._archiveArt(template)
          }
        }

        if (template.campaignId) {
          modalConfig.htmlDescription = CampaignService.getArchiveHtmlDescription(template.campaignName)
        } else {
          modalConfig.description = message
        }

        ConfirmationModalService.createModal(modalConfig)
      }
    }

    function _archiveTemplates (templates) {
      function _handleActionSuccess () {
        $scope.selectedTemplates = []
        templates = []
        skipPagingTo(0)
      }

      const templatesAreNotCustomizable = templates.every(template => !template.isCustomizable)
      const ids = templates.map(item => item.id)

      if ($scope.oFilters && $scope.oFilters.isArchived) {
        if (templatesAreNotCustomizable) {
          MessageService.warning({
            title: $translate.instant('beware'),
            text: $translate.instant('areYouSureUnarchiveTemplate'),
            confirmButton: $translate.instant('unarchive'),
            cancelButton: $translate.instant('cancel'),
            closeOnConfirm: true,
            showLoaderOnConfirm: true,
            allowOutsideClick: true,
            press: () => {
              api._batchUnarchiveTemplates(ids)
            }
          })

          return
        }

        api.getUnarchiveTemplateDialogController().then(({ unarchiveTemplateController }) => {
          ModalService.showModal({
            templateId: 'unarchiveTemplate.html',
            templateUrl: '/arts/dialogs/unarchive-template/unarchive-template-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: unarchiveTemplateController,
            data: {
              data: {
                isArchivingMultiples: true,
                templateIds: ids
              }
            }
          }).then(() => {
            $scope.oFilters.isArchived = false
          })
        })
      } else {
        if (templatesAreNotCustomizable) {
          MessageService.warning({
            title: $translate.instant('beware'),
            text: $translate.instant('areYouSureArchiveTemplate'),
            confirmButton: $translate.instant('archive'),
            cancelButton: $translate.instant('cancel'),
            closeOnConfirm: true,
            showLoaderOnConfirm: true,
            allowOutsideClick: true,
            press: () => {
              api._batchArchiveTemplates(ids)
            }
          })

          return
        }

        api.getArchiveTemplateDialogController().then(({ archiveTemplateController }) => {
          ModalService.showModal({
            templateId: 'archiveTemplate.html',
            templateUrl: '/arts/dialogs/archive-template/archive-template-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: archiveTemplateController,
            data: {
              data: {
                isArchivingMultiples: true,
                templateIds: ids
              }
            }
          }).then(sucess => {
            if (sucess) {
              _handleActionSuccess()
              $scope.$emit('reload-arts-page')
            }
          })
        })
      }
    }

    // method that opens the old preview
    $scope.openTemplateDialog = function (template) {
      api._openTemplateDialog(template.id)
    }

    $scope.goToCustomize = function (template) {
      $state.go('customizeArt', {
        idArt: template.id,
        hideConvertTemplateButton: true,
        from: $state.current.name,
        fromParams: $state.params
      })
    }

    $scope.downloadTemplateClick = function (template) {
      if (!template.isCustomizable) {
        $q.all([
          ArtsService.getArtDetailById(template.id),
          ArtsService.getInfosBusinessData(template.id)
        ]).then(([art, businessDataInfo]) => {
          const productValue = !!document.querySelector('#canvas_group [data-product]')
          SegmentService.track('downloaded-art', {
            art_id: template.id,
            photoframes: 0,
            permission: 'download',
            type: 'only_download',
            template_id: art.baseTemplateId,
            element_hyperlink: art.hyperlinks,
            format_type: template?.productType?.toLowerCase?.(),
            business_data: businessDataInfo.hasPlaceholdersSaved,
            video: art.hasVideo,
            product: productValue
          })
        })

        $scope.downloading = true
        const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DOWNLOAD, [template.id])
        const file = Utils.downloadFile(url, {
          artId: template.id
        })
        $scope.downloading = false
        return file
      } else {
        api.getDownloadDialogController().then(({ DownloadDialogController }) => {
          const downloadDialog = UdsModalService.createModal({
            controller: DownloadDialogController,
            modalName: 'downloadDialog',
            data: {
              _iArtId: template.id,
              _customizationLevel: template.customizationLevel,
              _isCustomizable: template.isCustomizable,
              _sDownloadOption: template.downloadOption,
              _iProductId: template.productId
            }
          })

          downloadDialog.open()
        })
      }
    }

    $scope.openFormatDialog = () => {
      api.getArtSizeDialogController().then(({ ArtSizeDialogController }) => {
        const artSizeDialog = UdsModalService.createModal({
          controller: ArtSizeDialogController,
          modalName: 'artSizeDialog'
        })

        artSizeDialog.open()
      })
    }

    $scope.getPageTitle = () => {
      return !$scope.selectedTemplates.length ? $translate.instant('companyTemplates') : $translate.instant('selectingTemplates')
    }

    $scope.openTemplateSettings = function (event, template) {
      event.stopPropagation()
      Mousetrap.unbind('space')

      api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
        const templatePropertiesDialog = UdsModalService.createModal({
          controller: TemplatePropertiesDialogController,
          modalName: 'templatePropertiesDialog',
          data: {
            art: {
              ...template,
              layers: template.art_layers
            },
            isEditing: true,
            shouldConvertToTemplate: false,
            isCustomizable: template.isCustomizable,
            artCollectionId: template.artCollectionId
          },
          onClose: (info) => {
            Mousetrap.bind('space', (event) => $scope.handleOpenQuickPreview({ event }))

            $location.search({ ...$state.params, id: null, template: null })

            if ($scope.templateParam) {
              $scope.templateParam.id = template.id
            }

            if (info && info.wasUpdated) {
              $scope.$emit('reload-arts-page')
            }
          }
        })

        templatePropertiesDialog.open()
      })
    }

    $scope.toggleTemplateSelected = (template) => {
      template.selected = !template.selected
      Utils.toggleItemOnArray($scope.selectedTemplates, template, (a, b) => a.id === b.id)
    }

    function _openTemplateDialog (id) {
      api.getUploadTemplateDialogController().then(({ UploadTemplateDialogController }) => {
        ModalService.showModal({
          templateId: 'uploadTemplate.html',
          templateUrl: '/arts/dialogs/upload-template/upload-template-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          controller: UploadTemplateDialogController,
          data: {
            isUploadingTemplate: false,
            id
          }
        }).then(info => {
          $location.search({ ...$state.params, template: null })
          if (info && info.wasUpdated) {
            skipPagingTo(0)
          }
        })
      })
    }

    function skipPagingTo (index, fromParams, viewType) {
      if ($scope.oFilters?.isArchived) {
        $scope.floatingBarLocation = 'archivedArtList'
      } else {
        $scope.floatingBarLocation = 'materialsManagement'
      }
      let pageToken = Number(index)
      const search = $scope.search || null

      if (!fromParams || !pageToken) {
        pageToken = isNaN(pageToken) ? 1 : pageToken + 1
      }

      $scope.currentPage = pageToken
      $scope.indexToken = pageToken - 1

      const page = pageToken !== 1 ? pageToken : null

      $location.search({ ...$stateParams, search, page })

      const skip = (pageToken - 1) * $scope.top

      const startFromId = fromParams?.startFromId || null
      const previewSort = fromParams?.previewSort || null

      ArtsService.getCompanyTemplates($scope.top, skip, $scope.oFilters, $scope.selectedOrder, $scope.search, startFromId, previewSort, null, viewType).then(api._successGetTemplates)
    }

    function _successGetTemplates (res) {
      $scope.templateCount = res.d.__count
      $scope.templates = res.d.results

      api._checkIfPageExists($scope.templateCount, $scope.top)

      $scope.templates.forEach(template => {
        template.productType = template?.productType?.toLowerCase?.()
        if (template.productType === 'printable') {
          template.sizeUnit = 'cm'
          template.width = api.pixelToCentimeter(template.width, template.sizeScale)
          template.height = api.pixelToCentimeter(template.height, template.sizeScale)
        } else {
          template.sizeUnit = 'px'
        }
      })

      $scope.loading = false
    }

    function pixelToCentimeter (pixelValue, scale) {
      pixelValue = pixelValue * scale
      return parseInt(pixelValue / (72 / 2.54), 10)
    }

    function _calcCardsPerLine () {
      const container = document.querySelector('.thumbnail-visualization')
      const computedStyle = window.getComputedStyle(container)
      const width = Number.parseInt(computedStyle.width) - 64
      const cardsPerLine = Math.floor(width / 258)

      thumbTop = cardsPerLine * 3
      $scope.top = thumbTop
    }

    function _checkIfPageExists (count, top) {
      if (!count) {
        return
      }

      const paginationSize = Math.ceil(count / top)

      if ($scope.currentPage > paginationSize) {
        skipPagingTo(1, true)
        ToastService.showErrorToast($translate.instant('thisPageDoesNotExist'))
      }
    }

    function _batchArchiveTemplates (templateIds) {
      return ArtsService.bulkArchiveTemplates(templateIds)
        .then(() => {
          ToastService.defaultSuccessToast()
          $scope.$emit('reload-arts-page')
        })
    }

    function _batchUnarchiveTemplates (templateIds) {
      $scope.oFilters.isArchived = false
      function _unarchiveTemplatesCallBack () {
        return ArtsService.bulkUnarchiveTemplates(templateIds)
          .then(() => {
            ToastService.defaultSuccessToast()
            $scope.$emit('reload-arts-page')
          })
      }

      return api._moveToCollection(templateIds, {}).then(changed => {
        if (changed) {
          return _unarchiveTemplatesCallBack()
        }
      })
    }

    function _moveToCollection (templateIds) {
      return api.getMoveTemplateCollectionController().then(({ MoveTemplateCollectionController }) => {
        return ModalService.showModal({
          templateId: 'moveTemplateCollection.html',
          templateUrl: '/arts/dialogs/move-template-collection/move-template-collection-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: MoveTemplateCollectionController,
          data: {
            data: templateIds,
            type: 'multipleTemplates'
          }
        }).then(info => info.changed)
      })
    }

    $scope.getPreviewAssets = (section, top, skip, startFromId, previewSort) => {
      const deferred = $q.defer()
      ArtsService.getCompanyTemplates(top, skip, null, null, null, startFromId, previewSort)
        .then(({ d }) => {
          deferred.resolve({
            assets: d.results,
            count: d.__count
          })
        })

      return deferred.promise
    }

    $scope.openAssetPreview = (template, location) => {
      AssetPreviewService.openAssetPreview({
        asset: template,
        location,
        getPreviewAssets: $scope.getPreviewAssets
      })
    }

    function _openImportTemplate () {
      $scope.openImportTemplate()
    }

    function _openImportModal () {
      $scope.openImportModal()
    }

    function _openFormatDialog () {
      $scope.openFormatDialog()
    }

    function _onFilter (filters) {
      $scope.oFilters = filters
      skipPagingTo(0)
    }

    function _setHeader (visualization) {
      const param = visualization === 'thumb' ? 'list' : 'thumb'
      const icon = visualization === 'thumb' ? 'menu' : 'grid'

      const createNewDropdownBtns = [
        {
          icon: 'upload',
          label: $translate.instant('importMaterial'),
          onClick: api._openImportTemplate
        }
      ]

      if ($scope.companyFeatures.artsCustomization.access) {
        createNewDropdownBtns.push({
          icon: 'upload',
          label: $translate.instant('importSvgTemplate'),
          onClick: api._openImportModal
        }, {
          icon: 'file-plus',
          label: $translate.instant('createBlankTemplate'),
          onClick: api._openFormatDialog
        })
      }

      const rightButtons = [
        {
          type: 'dropdown',
          btnType: 'primary',
          label: $translate.instant('createNew'),
          icon: 'plus',
          options: createNewDropdownBtns
        },
        {
          type: 'icon',
          icon,
          onClick: api._changeVisualization.bind(null, param)
        }
      ]

      const exhibitDefaultValue = {
        label: $translate.instant('actives'),
        value: false,
        icon: 'success',
        active: true,
        disabled: false
      }

      const filters = [
        {
          name: 'isArchived',
          type: 'FILTER_BUTTON_SELECT',
          grouped: false,
          defaultValue: exhibitDefaultValue,
          props: {
            label: $translate.instant('exhibit'),
            multiple: false,
            switchMode: true,
            udsDisabled: false,
            options: [
              exhibitDefaultValue,
              {
                label: $translate.instant('archivedPlural'),
                value: true,
                icon: 'archive',
                active: false,
                disabled: false
              }
            ]
          }
        }
      ]

      if ($scope.companyFeatures.artsCustomization.access) {
        filters.push({
          name: 'customizationLevel',
          type: 'FILTER_BUTTON_SELECT',
          grouped: false,
          defaultValue: null,
          props: {
            label: $translate.instant('customizationLevel'),
            multiple: false,
            switchMode: false,
            udsDisabled: false,
            options: [
              {
                label: $translate.instant('permissionFree'),
                value: 'FREE_STYLE',
                icon: 'unlock',
                active: false,
                disabled: false
              },
              {
                label: $translate.instant('permissionRestricted'),
                value: 'RESTRICTED',
                icon: 'lock',
                active: false,
                disabled: false
              },
              {
                label: $translate.instant('customizable'),
                value: 'CUSTOMIZABLE',
                icon: 'lock-filled',
                active: false,
                disabled: false
              }
            ]
          }
        },
        {
          name: 'needApproval',
          type: 'FILTER_BUTTON_SELECT',
          grouped: false,
          defaultValue: null,
          props: {
            label: $translate.instant('templates'),
            multiple: false,
            switchMode: false,
            udsDisabled: false,
            options: [
              {
                label: $translate.instant('withApproval'),
                value: true,
                icon: 'check',
                active: false,
                disabled: false
              },
              {
                label: $translate.instant('withoutApproval'),
                value: false,
                icon: 'close',
                active: false,
                disabled: false
              }
            ]
          }
        })
      }

      filters.push({
        name: 'artTagIds',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('filterByTags'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          loadButtonLabel: '',
          type: 'tag',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (name, top, skip) => TagsService.getTags({ name, top, skip })
      },
      {
        name: 'formatId',
        type: 'INPUT_SELECT',
        grouped: true,
        defaultValue: null,
        props: {
          label: $translate.instant('product'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          pricing: false,
          pricingTooltip: '',
          pricingTooltipPosition: 'top',
          options: []
        },
        loadData: (search, top, skip) => FormatsService.getFormats({ search, top, skip })
      },
      {
        name: 'groupId',
        type: 'INPUT_SELECT',
        grouped: true,
        defaultValue: null,
        props: {
          label: $translate.instant('userGroup'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          pricing: false,
          pricingTooltip: '',
          pricingTooltipPosition: 'top',
          options: []
        },
        loadData: (searchTerm, top, skip) => GroupService.getGroups(top, skip, { searchTerm })
      },
      {
        name: 'createdAt',
        type: 'DATE_PICKER',
        grouped: true,
        defaultValue: '',
        props: {
          locale: $rootScope.oUser.locale,
          label: $translate.instant('creationDate'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      },
      {
        name: 'templateExpiration',
        type: 'DATE_PICKER',
        grouped: true,
        defaultValue: '',
        props: {
          locale: $rootScope.oUser.locale,
          label: $translate.instant('expiration'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      })

      $scope.headerToolbar = {
        rightButtons,
        search: {
          filters,
          onFilter: api._onFilter,
          onSearch: api._onSearch
        }
      }
    }

    function _handleCompanyFeatures () {
      return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
        const customizableArtsSlug = String('ARTS.CUSTOMIZABLE_ARTS')
        $scope.companyFeatures.artsCustomization.access = !!features[customizableArtsSlug]
      })
    }

    function _archiveArt (template) {
      ArtsService.archiveArt(template.id).then(() => {
        ToastService.defaultSuccessToast()
        skipPagingTo(0)
      }).catch(ToastService.defaultErrorToast)
    }

    $scope.isPreviewEnabled = AssetPreviewService.isPreviewEnabled

    function _unselectAllAssets () {
      $scope.selectedTemplates.forEach(template => {
        template.selected = false
      })

      $scope.selectedTemplates = []
    }

    $scope.unselectAllAssets = function () {
      api._unselectAllAssets()
    }

    $scope.handleTemplateClick = function (template) {
      if (template.selected) {
        template.selected = false
        $scope.selectedTemplates = $scope.selectedTemplates.filter(t => t.id !== template.id)
      } else {
        template.selected = true
        $scope.selectedTemplates.push(template)
      }
    }

    $scope.openBulkTemplateDialog = function (templates) {
      api._openBulkTemplateDialog(templates)
    }

    $scope.openArchiveTemplateDialog = function (templates) {
      api._archiveTemplates(templates)
    }
  }
})()
